
import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './../Navigation.css';

var SideNavBar = function SideNavBar(_ref) {
    var children = _ref.children;

    return React.createElement(
        'div',
        { className: 'side-navigation' },
        React.createElement(
            Card,
            null,
            React.createElement(
                Card.Body,
                { className: 'p-3' },
                children
            )
        )
    );
};

SideNavBar.defaultProps = {};
SideNavBar.propTypes = process.env.NODE_ENV !== "production" ? {} : {};
export default SideNavBar;